export default {
    BASE_URL: 'https://api.wisdom-pool.bloggernepal.com/'
}